import { gql } from '@apollo/client';

const GET_ELIGIBLE_ASSESSMENT_YEARS = gql`
  query GetEligibleAssessmentYears {
    getEligibleAssessmentYears {
      year
      businessUnits {
        businessUnitName
        active
        deadlineTimestamp
      }
    }
  }
`;

const ACTIVATE_BUSINESS_UNIT_YEAR = gql`
  mutation ActiveBusinessUnitForYear($businessUnit: String!, $year: Int!) {
    activateBusinessUnitForYear(businessUnit: $businessUnit, year: $year) {
      year
      businessUnits {
        businessUnitName
        active
      }
    }
  }
`;

const UPDATE_BUSINESS_UNIT_DEADLINE_YEAR = gql`
  mutation UpdateBusinessUnitDeadlineForYear(
    $businessUnit: String!
    $year: Int!
    $deadlineTimestamp: String!
  ) {
    updateBusinessUnitDeadlineForYear(
      businessUnit: $businessUnit
      year: $year
      deadlineTimestamp: $deadlineTimestamp
    )
  }
`;

export {
  GET_ELIGIBLE_ASSESSMENT_YEARS,
  ACTIVATE_BUSINESS_UNIT_YEAR,
  UPDATE_BUSINESS_UNIT_DEADLINE_YEAR,
};
